/**
 * Отправляет уведомление админу о новой записи через Telegram бота
 */
export async function notifyAdminAboutBooking(booking: {
  clientId: number;
  clientName?: string;
  date: string;
  time: string;
  serviceName: string;
  employeeName?: string;
  bookingId?: string | number;
}): Promise<void> {
  try {
    const response = await fetch('/api/bookings/notify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(booking)
    });

    if (!response.ok) {
      console.error('Failed to notify admin about booking');
    }
  } catch (error) {
    console.error('Error notifying admin about booking:', error);
  }
}

/**
 * Отправляет уведомление админу об отмене записи через Telegram бота
 */
export async function notifyAdminAboutCancellation(booking: {
  clientId: number;
  clientName?: string;
  date: string;
  time: string;
  serviceName: string;
  bookingId?: string | number;
}): Promise<void> {
  try {
    const response = await fetch('/api/bookings/cancel-notify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(booking)
    });

    if (!response.ok) {
      console.error('Failed to notify admin about cancellation');
    }
  } catch (error) {
    console.error('Error notifying admin about cancellation:', error);
  }
}
